export default __webpack_public_path__ + "agent_bg14d40e0.png";